import {useCallback, useState} from 'react';
import {CreateChildOrganizationModal} from '../modals/create-child-organization-modal';

type UseCreateChildOrganizationModalOptions = {
  agencyId: string;
};

export const useCreateChildOrganizationModal = ({
  agencyId,
}: UseCreateChildOrganizationModalOptions) => {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  const Modal = useCallback(
    () => (
      <CreateChildOrganizationModal
        open={isOpen}
        onOpenChange={setIsOpen}
        agencyId={agencyId}
      />
    ),
    [isOpen, agencyId],
  );

  return {Modal, open, close, isOpen};
};
